export default __webpack_public_path__ + "static/media/OLDMUTUALTEXT.e2146cb9.svg";